import { ColorSwatch } from "@mantine/core";
import React from "react";
const MantineColorSwatch = (props: any) => {
    const { color, children, className, radius, onClick, style, component } = props;
    return (
        <ColorSwatch color={color} className={className} style={style} onClick={onClick} component={component} radius={radius}>
            {children}
        </ColorSwatch >
    )
}
export default MantineColorSwatch;